import { FC } from 'react';
import { IconProps } from '@base/icon/interface';
import { SVG } from '@base/icon/SVG';

export const IconArrow2: FC<IconProps> = props => (
    <SVG
        {...props}
        path="M481.834667 183.168a42.666667 42.666667 0 0 1 60.330666 0l298.666667 298.666667a42.666667 42.666667 0 0 1-60.330667 60.330666L554.666667 316.330667V810.666667a42.666667 42.666667 0 1 1-85.333334 0V316.330667l-225.834666 225.834666a42.666667 42.666667 0 0 1-60.330667-60.330666l298.666667-298.666667z"
    />
);